import React from "react";
import InfoItem from "../InfoItem/InfoItem";
import {checkEmptyObj, moveElementToEnd} from "helper/common";
import ArrayLabel from "../ArrayLabel/ArrayLabel";
import {Divider, Space} from "antd";
const Extraocular = props => {
  const {data, isShow = true} = props;
  const render = () => {
    return (
      <>
        {isShow && <div className="title">Vận nhãn và lác:</div>}
        <Space direction="vertical">
          {moveElementToEnd(
            Object.keys(data).filter(
              key =>
                data[key] &&
                key != "show" &&
                key != "Lác hiện" &&
                key != "Chiều ngang" &&
                key != "Lác trong" &&
                key != "Lác liệt" &&
                key != "Lác ẩn"
            ),
            "Ghi chú"
          ).map(key => {
            if (key == "Lác") {
              return (
                <div>
                  • Lác: {data["Lác"]}{" "}
                  {data["Lác hiện"] || data["Lác ẩn"]
                    ? `- ${data["Lác hiện"] || data["Lác ẩn"]}`
                    : ""}
                  {data["Lác hiện"] ? " -" : ""}
                  {data["Chiều ngang"] || data["Chiều dọc"]}{" "}
                  {data["Lác trong"] || data["Lác ngoài"]
                    ? `- ${data["Lác trong"] || data["Lác ngoài"]}`
                    : ""}
                  {data["Lác liệt"] && (
                    <div>
                      <ArrayLabel
                        data={data["Lác liệt"]}
                        name="Lác liệt"
                      ></ArrayLabel>
                    </div>
                  )}
                </div>
              );
            } else {
              return (
                <div>
                  <InfoItem label={key} value={data[key]}></InfoItem>
                </div>
              );
            }
          })}
        </Space>
        <Divider className="border-grey"></Divider>
      </>
    );
  };
  return <div className="Extraocular">{!checkEmptyObj(data) && render()}</div>;
};
export default Extraocular;
